import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Для тестирования: всегда аутентифицированы
  const [currentUser, setCurrentUser] = useState({ id: 1, name: 'Тестовый Пользователь' });
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (credentials) => {
    // В тестовом режиме просто возвращаем фейкового пользователя
    return currentUser;
  };

  const handleRegister = async (userData) => {
    // В тестовом режиме просто возвращаем фейкового пользователя
    return currentUser;
  };

  const handleLogout = async () => {
    // Для тестирования: не делаем ничего
    console.log('Выход выполнен (тестовый режим)');
  };

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        isAuthenticated,
        loading,
        login: handleLogin,
        register: handleRegister,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
